import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { warm } from '../../../style/variables';

export const FormGrid = styled(Grid)(
  ({ theme }) => `
    ${theme.breakpoints.down('lg')}{
      margin: 0;
      padding: 0;
      background: ${warm[50]};
      max-width: 100% !important;
    },`,
);

export const Form = styled('form')(
  ({ theme }) => `
     position: relative;
     & button {
       width: fit-content;
     }
    ${theme.breakpoints.up('md')} {
      margin-top: 40px;
      margin-bottom: 40px;
    },`,
);

export const Jumbotron = styled(Box)(
  ({ theme }) => `
    padding: 4rem 2rem;
    background: ${warm[50]};
    margin-bottom: 0;
    ${theme.breakpoints.up('md')} {
      padding-top: 8rem;
      padding-bottom: 8rem;
    },
    ${theme.breakpoints.down('lg')} {
      padding: 0;
      margin-bottom: 0;
    },
`,
);
